import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";
import { Message } from 'element-ui';
import sysConfigApi from "@/api/sysConfig";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const activeName = ref("warning");

const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
const sysConfig = ref({
  id:1,
  config:{
    earlyWarn:{
      instr: '',
      org: ''
    },
    loginErrorNum: 5,
    lockTime: 30,
    sessionTimeoutMinutes: 60,
    pwdExpires: 60
  }
});

onMounted(() => {
  getConfig();
});

const getConfig = () => {
  sysConfigApi.get().then((r: any) => {
    if(r.data.result === 0){
      Object.assign(sysConfig.value.config, r.data.data)
    }
  });
}

const saveData = () => {
  const {id, config} = sysConfig.value;
  sysConfigApi.edit({id: id, config: JSON.stringify(config)}).then((r: any) => {
    if(r.data.result === 0){
      Message.success("配置成功！");
    }
  });
}

const handleClick = () => {
  console.log("123");
}


return { __sfc: true,activeName, screenHeight, sysConfig, getConfig, saveData, handleClick }
}

})